<div class="product-item">
  <a tabindex="0" [routerLink]="{ cxRoute: 'product', params: item } | cxUrl">
    <cx-media [container]="item.images?.PRIMARY" format="product"></cx-media>
    <div class="cx-manufacturer">
      {{ item.manufacturer }}
    </div>
    @if (item.name) {
      <div class="cx-name">
        <a class="cx-link" [routerLink]=" { cxRoute: 'product', params: item } | cxUrl">
          {{ item.name }}
        </a>
      </div>
    }
  </a>
</div>
